var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMatic0)",
    d: "M8.288 9.497a.91.91 0 0 1 .917 0l2.096 1.252l1.423.814l2.1 1.252a.91.91 0 0 0 .913 0l1.667-.978c.27-.162.596-.463.596-.788V9.12c0-.326-.3-.626-.6-.788l-1.638-.952a.91.91 0 0 0-.912 0l-1.642.952c-.266.162-.351.462-.351.788v1.247l-1.286-.84V8.272c0-.326-.086-.626.214-.789l3.039-1.791a.91.91 0 0 1 .913 0l3.09 1.791a.88.88 0 0 1 .458.793v3.617a.89.89 0 0 1-.458.789l-3.09 1.791a.91.91 0 0 1-.913 0l-2.1-1.221l-1.423-.845l-2.1-1.221a.91.91 0 0 0-.913 0l-1.637.951c-.27.163-.651.463-.651.789v1.928c0 .326.355.626.651.79l1.637.976a.92.92 0 0 0 .917 0l1.637-.951c.27-.163.729-.463.729-.789v-1.247l1.286.84v1.252c0 .325-.292.625-.587.788L9.17 18.3a.89.89 0 0 1-.913 0l-3.09-1.791a.94.94 0 0 1-.454-.784v-3.618c0-.325.163-.625.458-.788z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMatic0",
    x1: 4.714,
    x2: 17.47,
    y1: 5.569,
    y2: 20.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F34C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7442DB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.b6cb6b907c651dffe4fde2ab84120f96.svg";
export { ForwardRef as ReactComponent };